function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M387 238V131C387 59 328 0 256 0S125 59 125 131v107H92c-18 0-33 15-33 33v188c0 19 15 33 33 33h328c18 0 33-14 33-33V271c0-18-15-33-33-33zm-197 0V131c0-36 30-65 66-65s66 29 66 65v107z"
}));